var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-container"},[_c('viewer-details',{attrs:{"filePath":_vm.filePath,"line-count":_vm.lineCount,"size":_vm.fileSize}}),_c('text-reader',{attrs:{"file":_vm.rawText,"lineCount":_vm.lineCount,"size":_vm.fileSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }